import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_DETAIL_SUCCESS,
  GET_GAME_CONFIGURATIONS_START,
  GET_GAME_CONFIGURATIONS_SUCCESS,
} from "./types";

const initialState = baseState => ({
  ...baseState,
  filters: [
    ...baseState.filters,
    {
      key: "softwareId",
      title: "label.software",
      icon: "software",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "invoicingCategoryId",
      title: "label.invoicing",
      icon: "invoicing",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "jackpotCategoryId",
      title: "label.jackpot",
      icon: "jackpot",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "genreId",
      title: "label.genre",
      icon: "genre",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "releaseDate",
      title: "label.release-date",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "releaseDateFrom",
      active: false,
      values: [],
      metadata: [],
      hidden: true,
    },
    {
      key: "releaseDateTo",
      active: false,
      values: [],
      metadata: [],
      hidden: true,
    },
    {
      key: "assetsCategorised",
      title: "label.assets-categorised",
      active: false,
      values: [],
      metadata: [],
    },
  ],
  detail: {
    loading: false,
  },
  configurations: {
    loading: false,
    results: [],
  },
});

const store = new BaseStore("games", initialState);

const reducer = {
  [GET_GAME_CONFIGURATIONS_START]: state => ({
    ...state,
    configurations: {
      ...state.configurations,
      loading: true,
    },
  }),
  [GET_GAME_CONFIGURATIONS_SUCCESS]: (state, payload) => ({
    ...state,
    configurations: {
      ...state.configurations,
      ...payload.configurations,
      loading: false,
    },
  }),
  [GET_DETAIL_SUCCESS]: (state, payload) => ({
    ...state,
    detail: {
      ...payload.detail,
      loading: false,
    },
  }),
};

export default store.reducer(reducer);
